import { useQuery } from '@tanstack/react-query';
import { useAuth } from 'context/AuthContext';
import { useGetCurrentSessionUser } from 'hooks/useGetCurrentSessionUser';
import { currentSelectedClientType } from 'features/Client/useSwitchClientList';
import { getNewAccountGroupBasicDetails } from './api';
import { NewAccountGroupBasicDetailsRequest, NewAccountGroupBasicDetailsResponse } from './types';

export function useGetAccountGroupBasicDetails({ accountNumber, newAccountGroupId }: Omit<NewAccountGroupBasicDetailsRequest, 'subClientId'>) {
    const { user } = useAuth();
    const currentSelectedClient = useGetCurrentSessionUser('currentSelectedClient') as currentSelectedClientType;
    const subClientId = currentSelectedClient?.clientId ?? user?.clientId;

    // QUERY
    const query = useQuery({
        queryKey: ["newAccountGroupBasicDetails", accountNumber, newAccountGroupId],
        queryFn: async () => {
            const { data } = await getNewAccountGroupBasicDetails({ subClientId, accountNumber, newAccountGroupId })
            return data as NewAccountGroupBasicDetailsResponse
        },
        cacheTime: 0,
        staleTime: 0,
        enabled: !!accountNumber && (!!newAccountGroupId || newAccountGroupId === null)
    });

    return query;
}